module.exports = __webpack_public_path__ + "img/no-authority.44a404bf.png";